<script setup>
import { edgeFromDtRange, post, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import { reactive } from 'vue'
const meta=reactive({stats:['status','wait','complete'],dtrange:[dayjs(new Date).subtract(7,'days').toDate(),new Date],tblheight:'100%',stat:'status',sortcol:'cdt',isasc:false
    ,heads:[{tk:'applicant',col:'applicant'},{tk:'status',col:'stat'},{tk:'apikey',col:'apikey'},{tk:'issuer',col:'issuer'},{tk:'dateofenrollment',col:'cdt'},{tk:'dateofmod',col:'mdt'},{tk:'issuingapikeys'},{tk:'delete'}]
    ,data:{rows:[]},page:1,size:20}),metaStore=useMetaStore()
,mod=async(type,row)=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/'+(type=='del'?'delapireq':'publishapikey'),row)
  metaStore.blockLoading(false)
  if(!res.isSuccess)return metaStore.toastKey('server_error',false)
  metaStore.toastKey(type=='del'?'thedeletioniscomplete':'openapikeypublished')
  search()
},sort=col=>{
  if(meta.data.rows.length==0)return
  if(meta.sortcol!=col)meta.sortcol=col
  else meta.isasc=!meta.isasc
  search()
},pop=async(type,row)=>{
  meta.poptype=null
  meta.popttl=null
  meta.popcont=null
  meta.popttl=metaStore.t('issuingapikeys')
  if(type=='del'){
    meta.popcont=metaStore.t('allassociateddatawilldisappear')+'<br/>'+metaStore.t('afterdeletionrecoveryisnotpossible')+'<br/>'+metaStore.t('shallweproceed')
  }else{
    meta.popcont=metaStore.t('issueapikeystotheselectedcustomers')+'<br/>'+metaStore.t('shallweproceed')
  }
  meta.popact=()=>mod(type,row)
  metaStore.pop({ison:true,callback:() =>meta.poptype=type})
},search=async()=>{
  const pms={...edgeFromDtRange(meta.dtrange),dtcol:'cdt',where:{},page:meta.page,size:meta.size,sortcol:meta.sortcol,isasc:meta.isasc}
  if(meta.stat!='status')pms.where.stat_eq_=meta.stat
  if(meta.searchval)pms.where.searchval=meta.searchval
  metaStore.blockLoading()
  meta.data=await post('rest/authed/admin/reqapikeys',pms)
  metaStore.blockLoading(false)
  meta.data=meta.data.data
  const mems=meta.data.subrows.mems
  meta.data.rows.forEach(row=>{
    row.issuingapikeys='keyissuance'
    if(row.apikey)row.issuingapikeys='reissuance'
    let mem=mems.find(mem=>mem.mid==row.mid)
    row.applicant=`${mem.mname}(${mem.mid})`
    if(row.admid){
      mem=mems.find(mem=>mem.mid==row.admid)
      row.issuer=`${mem.mname}(${mem.mid})`
    }
  })
  meta.tblheight=window.innerHeight-350
}
search()
</script>
<template>
  <div class="h-100 admapikey">
    <v-card flat>
      <v-card-title>{{ $t('applytousetheopenapi') }}</v-card-title>
      <v-sheet class="pa-3 bg-grey-lighten-3">
        <v-row>
          <v-col>
              <v-date-input hide-details variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="$calendar" v-model="meta.dtrange" :label="$t('select_range')" multiple="range"/>
          </v-col>
          <v-col cols="2">
            <v-select hide-details density="compact" variant="outlined" :items="meta.stats" v-model="meta.stat" :item-title="$t" :item-value="val=>val"/>
          </v-col>
          <v-col>
            <v-text-field hide-details density="compact" variant="outlined" :label="$t('pleaseenteryoursearchterm')" v-model="meta.searchval"/>
          </v-col>
          <v-col cols="1">
            <v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/>
          </v-col>
        </v-row>
      </v-sheet>
      <v-card-text class="pa-0 mt-3">
        <v-table fixed-header :height="meta.tblheight">
          <thead>
            <tr>
              <th class="text-center bg-grey-lighten-4" v-for="head in meta.heads">
                <div v-if="head.col=='stat'||head.col=='cdt'||head.col=='mdt'" class="cursor-pointer" @click="sort(head.col)">{{ $t(head.tk) }}
                  <v-icon v-if="meta.data.rows.length>0&&head.col==meta.sortcol" :icon="meta.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
                </div>
                <div v-else>{{ $t(head.tk) }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="meta.data.rows.length==0"><td class="text-center" :colspan="meta.heads.length">
              <v-icon class="me-2"/>{{ $t('noresultsfound') }}
            </td></tr>
            <tr v-else v-for="row in meta.data.rows" class="text-center">
              <td v-for="head in meta.heads">
                <v-btn v-if="head.tk=='issuingapikeys'" color="primary" :text="$t(row[head.tk])" @click="pop(!row.apikey?'publish':'republish',row)"/>
                <v-btn v-else-if="head.tk=='delete'" color="error" :text="$t('delete')" @click="pop('del',row)"/>
                <div v-else-if="head.col=='stat'">{{ $t(row[head.col]) }}</div>
                <div v-else-if="head.col=='cdt'||head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                <div v-else-if="head.col">{{ row[head.col] }}</div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-pagination class="ma-auto" v-if="meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
      </v-card-actions>
    </v-card>
    <Teleport v-if="meta.poptype" to="#popbody">
      <ConfirmCard :ttl="meta.popttl" :cont="meta.popcont" @cancel="metaStore.pop({ison:false})" @confirm="meta.popact"/>
    </Teleport>
  </div>
</template>
<style>
.admapikey .v-input__control{background-color: rgba(255,255,255,1);}
</style>
